import SectionHeading from "./SectionHeading.jsx";
import { platformTags } from "./data.js";

export default function Platform() {
  return (
<section className="bg-white px-4 pt-6 pb-10 sm:px-6 lg:px-8 lg:pt-10 lg:pb-16">      <div className="mx-auto grid max-w-7xl items-center gap-14 lg:grid-cols-2">
        <div>
          <SectionHeading
            eyebrow="Zero Friction"
            title="Buy from anywhere."
            highlight="book tickets anywhere."
          />

          <div className="mt-10 flex flex-wrap gap-3">
            {platformTags.map((tag) => (
              <div
                key={tag}
                className="rounded-full border  border-[#e0e7ff] bg-[#f6f4ff] px-5 py-3 text-sm font-semibold font-montserrat text-[#4C42FD] transition md:hover:-translate-y-0.5 "
              >
                {tag}
              </div>
            ))}
          </div>

          
        </div>

        <div className="rounded-[32px] border border-purple-100 bg-[#faf8ff] p-10 text-center shadow-[0_24px_64px_rgba(124,58,237,0.08)] sm:p-14">
          <div className="bg-gradient-to-r font-montserrat text-[#4C42FD] bg-clip-text text-7xl font-black tracking-[-0.06em] sm:text-8xl lg:text-[7rem]">
            10%
          </div>
          <div className="mt-4 text-2xl font-black font-montserrat text-[#0d0828]">Extra Benefit</div>
          <p className="mt-4 text-base font-montserrat leading-7 text-[#0d0828b3]">
            10% extra on top of whatever discount you see on any app or store
          </p>
        </div>
      </div>
    </section>
  );
}
